import { gsap } from '../animations';

/**
 * Animazioni d'ingresso del block "Servizi":
 * - intestazione (eyebrow/titolo/testo) in fade-up a stagger;
 * - card in fade-up a stagger all'ingresso della griglia;
 * - icone con un piccolo "pop" in scala, leggermente sfalsato sulla card.
 * Con reduced-motion resta tutto fermo e visibile (niente gsap.from).
 */
export function initServizi() {
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	document.querySelectorAll( '[data-tm-servizi]' ).forEach( ( block ) => {
		const head = block.querySelector( '[data-tm-servizi-head]' );
		if ( head && head.children.length ) {
			gsap.from( head.children, {
				y: 24,
				opacity: 0,
				duration: 0.7,
				ease: 'power3.out',
				stagger: 0.1,
				scrollTrigger: { trigger: head, start: 'top 84%', once: true },
			} );
		}

		const list = block.querySelector( 'ul' );
		const cards = list ? list.querySelectorAll( ':scope > li' ) : [];
		if ( ! cards.length ) {
			return;
		}

		// Card e icone sotto un'unica timeline: le icone "scattano" durante il fade-up.
		const tl = gsap.timeline( {
			scrollTrigger: { trigger: list, start: 'top 82%', once: true },
		} );

		tl.from( cards, {
			y: 28,
			opacity: 0,
			duration: 0.6,
			ease: 'power3.out',
			stagger: 0.07,
		} );

		tl.from(
			list.querySelectorAll( 'li > span' ),
			{
				scale: 0.4,
				duration: 0.5,
				ease: 'back.out(1.8)',
				stagger: 0.07,
			},
			'<0.12'
		);
	} );
}
